import React from 'react';
import Navbar from '../Navbar';
import { useLocation } from 'react-router-dom';

const PublicLayout = ({ children }) => {
  const location = useLocation();
  const isInvoicePage = location.pathname.startsWith('/invoice');

  return (
    <>
      {!isInvoicePage && <Navbar />}
      <main className={isInvoicePage ? '' : 'pt-0'}>
        {children}
      </main>
    </>
  );
};

export default PublicLayout;
